import React, { ReactNode } from "react";
import { Box, BoxProps, Typography } from "@mui/material";
import styled from "@emotion/styled";
import { YTDPercents } from "@components/common";
import { MandatorTypography } from "@components/MandatorTypography";

const Container = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
`;

const PercentWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
`;

const FirstLine = styled.div<{ margin?: number }>`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.palette.text.secondary};
  & > :not(style) {
    margin-right: ${({ theme }) => theme.spacing(4)};
  }
`;

export interface CardLabelProps extends BoxProps {
  icon?: ReactNode;
  title: string;
  headline?: string;
  subtitle?: string;
  percent?: number;
  caption?: ReactNode;
  className?: string;
  firstLineMargin?: number;
}

export const CardLabel = ({
  icon,
  title,
  subtitle,
  headline,
  percent,
  className,
  caption,
  firstLineMargin,
  ...props
}: CardLabelProps) => {
  return (
    <Container className={className} {...props}>
      {caption}
      <FirstLine margin={firstLineMargin}>
        <TitleContainer>
          {icon}
          <MandatorTypography variant="caption2" noWrap>
            {title}
          </MandatorTypography>
        </TitleContainer>
        {percent != null && (
          <PercentWrapper>
            <YTDPercents value={percent} showArrows />
          </PercentWrapper>
        )}
      </FirstLine>
      {headline && (
        <Typography variant="h4" noWrap>
          {headline}
        </Typography>
      )}

      {subtitle && (
        <Typography variant="caption" color="text.tertiary">
          {subtitle}
        </Typography>
      )}
    </Container>
  );
};
